import { Route, Routes, useLocation } from 'react-router-dom'
import Lesson from './Lesson'
import Lessons from './Lessons'
import Learning from './Learning'
import FloatingBannerGroup from './FloatingBannerGroup'
import LeftBannerImage from '../../resources/images/left_banner_2.png'
import FormatDataBannerImage from '../../resources/images/format_data_banner.png'
import ClassInitializationBannerImage from '../../resources/images/class_initialization_banner.png'

const BANNERS = [
  {
    image: LeftBannerImage,
    href: 'https://sblog.i-scream.co.kr/pretty56/17659',
    storageKey: 'hideLeftBannerUntil',
  },
  {
    image: FormatDataBannerImage,
    href: 'https://www.i-scream.co.kr/user/custom/notice_view.do?no=26832',
    storageKey: 'hideFormatDataBannerUntil',
    closeButtonColor: '#ffffff',
    hideButtonBgColor: '#d9d9d9',
    hideButtonTextColor: '#000000',
  },
  // {
  //   image: ClassInitializationBannerImage,
  //   href: 'https://1promath.notion.site/AI-174b8cfa9a12806491b8e4b82974d0dc',
  //   storageKey: 'hideClassInitializationBannerUntil',
  //   closeButtonColor: '#ffffff',
  //   hideButtonBgColor: '#d9d9d9',
  //   hideButtonTextColor: '#000000',
  // },
]

const Content = ({ startReload, teacher, setTeacher, school, lessonInfo, classes, setClasses, classDetails, setClassDetails }) => {
  const location = useLocation()
  const isLearning = location.pathname.includes('/learning')

  return (
    <div className={'h-full'}>
      {!isLearning && <FloatingBannerGroup banners={BANNERS} />}
      <Routes>
        <Route path={'list'} element={<Lessons
          startReload={startReload}
          teacher={teacher}
          school={school}
          lessonInfo={lessonInfo}
          classes={classes}
          setClasses={setClasses}
          classDetails={classDetails}
          setClassDetails={setClassDetails}
        />}/>
        <Route path={'details'} element={<Lesson
          startReload={startReload}
          teacher={teacher}
          setTeacher={setTeacher}
          school={school}
          lessonInfo={lessonInfo}
          classes={classes}
          setClasses={setClasses}
          classDetails={classDetails}
          setClassDetails={setClassDetails}
        />}/>
        <Route path={'learning'} element={<Learning
          startReload={startReload}
          teacher={teacher}
          lessonInfo={lessonInfo}
          classDetails={classDetails}
        />}/>
        <Route path="*" element={<Lessons
          startReload={startReload}
          teacher={teacher}
          school={school}
          lessonInfo={lessonInfo}
          classes={classes}
          setClasses={setClasses}
          classDetails={classDetails}
          setClassDetails={setClassDetails}
        />}/>
      </Routes>
    </div>
  )
}

export default Content
